export default __webpack_public_path__ + "static/media/facetime.ac519bc5.svg";